/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import IKUtils from 'innerken-js-utils'
import i18n from '@/i18n'
import hillo from 'hillo'
import Swal from 'sweetalert2'
import { random } from 'lodash-es'
import dayjs from 'dayjs'

export function emptyOrIncludes (arr, item) {
  return arr.length === 0 || arr.includes(item)
}

export function searchData (data, word, key) {
  return data.filter(d => {
    if (!word) {
      return true
    } else {
      const words = word.split(' ')
      return words.every(w => d[key].toLowerCase().includes(w))
    }
  })
}

export function wordContainsIn (word, text) {
  if (!word) {
    return true
  } else {
    const words = word.toLowerCase().split(' ')
    return words.every(w => text.toLowerCase().includes(w))
  }
}

export const Rules = {
  required: value => !!value || i18n.t('required'),
  counter: value => value.length <= 20 || i18n.t('MaxCharacters20'),
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || i18n.t('InvalidMail')
  },
  ip: value => {
    return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      value) || this.$t('pls_input_suitable_IP')
  }
}

/**
 *
 * @param action
 * @param {string} title
 * @param {string} content
 * @returns {Promise<void>}
 */
export async function sureTo (action, content = '', title = i18n.t('are_you_sure')) {
  const res = await IKUtils.showConfirmAsyn(i18n.t(content), i18n.t(title))
  IKUtils.showLoading(true)
  if (res.isConfirmed) {
    await action()
  } else {
    IKUtils.toast(i18n.t('cancel_success'), 'info')
  }
}

export async function sureToDelete (action, content = '', title = i18n.t('are_you_sure_to_delete') + '?') {
  const res = await IKUtils.showConfirmAsyn(i18n.t(content), i18n.t(title))
  if (res.isConfirmed) {
    await action()
    IKUtils.toast(i18n.t('delete_success'), 'success')
  }
}

export function findLangEntityInLangArr (lang, arr) {
  return arr.find(d => d.lang.toLowerCase() === lang.toLowerCase()) ?? null
}

export function copyToAll (field, arr) {
  const [de, zh, en] = [
    findLangEntityInLangArr('DE', arr), findLangEntityInLangArr('ZH', arr), findLangEntityInLangArr('EN', arr)
  ]

  for (const fieldKey of field.childKey) {
    const [deContent, zhContent, enContent] = [de, zh, en].map(it => it[fieldKey])
    const target = deContent || zhContent || enContent

    const empty = [de, zh, en].filter(it => !it[fieldKey])
    for (const key of empty) {
      key[fieldKey] = target
    }
  }
}

export function showSuccessMessage (title) {
  IKUtils.toast(title, 'success')
}

export function showErrorMessage (title) {
  IKUtils.toast(title, 'error')
}

export async function fastSweetAlertRequest (title, input, url, dataName, dataObj, method = 'POST', allowEmpty = false,
  body = null, inputValue = '') {
  dataObj[dataName] = ''
  const callBack = function (method, data) {
    const request = method === 'POST' ? hillo.post : hillo.silentGet
    dataObj[dataName] = data
    return request(url, dataObj, { silent: true })
      .then(response => {
        return response
      })
      .catch(error => {
        Swal.showValidationMessage(`Request failed: ${error?.data?.info ?? i18n.t('error')}`)
      })
  }

  const result = await Swal.fire({
    title,
    html: body,
    input,
    inputAttributes: {
      autocapitalize: 'off'
    },
    inputValue,
    showCancelButton: true,
    confirmButtonText: i18n.t('confirm'),
    cancelButtonText: i18n.t('cancel'),
    showLoaderOnConfirm: true,
    preConfirm: (data) => {
      if (!data && !allowEmpty) {
        return false
      }
      return callBack(method, data)
    },
    allowOutsideClick: () => !Swal.isLoading()
  })
  if (result.value || allowEmpty) {
    result.value.originalData = dataObj[dataName]
    return result.value
  } else {
    return false
  }
}

export function pickOneFromArray (arr) {
  const index = random(0, arr.length - 1)
  return arr[index]
}

export function rateDisplay (rate) {
  if (rate === Infinity || rate === -Infinity || (!rate && rate !== 0)) {
    return '--'
  }
  return (parseFloat(rate) * 100).toFixed(2) + '%'
}

export function cantLessThan0 (number) {
  return number > 0 ? number : 0
}

export async function saveFile (file) {
  return (await hillo.postWithUploadFile('https://cloud-v2.aaden.io/uploadFile', {
    file
  }))
}

export function fromNowTimeDisplay (timestamp) {
  if (timestamp) {
    return dayjs(timestamp).format('dddd, MMMM DD, YYYY, h:mm:ss a')
  } else {
    return '日期有古怪'
  }
}

export function fromNowTimestamp (timestamp) {
  if (timestamp) {
    return dayjs(timestamp).fromNow()
  } else {
    return '日期有古怪'
  }
}

export const AllMonthDisplay = [
  { name: 'January', value: '1' },
  { name: 'February', value: '2' },
  { name: 'March', value: '3' },
  { name: 'April', value: '4' },
  { name: 'May', value: '5' },
  { name: 'June', value: '6' },
  { name: 'July', value: '7' },
  { name: 'August', value: '8' },
  { name: 'September', value: '9' },
  { name: 'October', value: '10' },
  { name: 'November', value: '11' },
  { name: 'December', value: '12' }
]
